// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expense-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .expense-form-container {
    padding: 1rem;
  }
}
.expense-form-container .expense-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.expense-form-container .expense-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.expense-form-container .expense-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modal-expense-form-container {
  padding: 0rem !important;
  min-height: auto;
}

.uploaded-file {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.uploaded-file a {
  color: #0369a1;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  flex: 1 1;
}
.uploaded-file a:hover {
  text-decoration: underline;
}
.uploaded-file .cancel-upload-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.uploaded-file .cancel-upload-button:hover {
  background-color: #dc2626;
}
.uploaded-file .cancel-upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}

.expense-form-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: expense-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .expense-form-card {
    padding: 1rem;
    width: 100%;
  }
}
.expense-form-card .expense-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-title {
    font-size: 1.25rem;
  }
}
.expense-form-card .expense-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.expense-form-card .form-section {
  margin-bottom: 1.5rem;
}
.expense-form-card .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.expense-form-card .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.expense-form-card .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.expense-form-card .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .expense-form-card .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.expense-form-card .expense-form-group,
.expense-form-card .form-group {
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
}
.expense-form-card .expense-form-group:last-child,
.expense-form-card .form-group:last-child {
  margin-bottom: 0;
}
.expense-form-card .expense-form-group .expense-form-label,
.expense-form-card .expense-form-group label,
.expense-form-card .form-group .expense-form-label,
.expense-form-card .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.expense-form-card .expense-form-group .expense-form-label .expense-form-required,
.expense-form-card .expense-form-group label .expense-form-required,
.expense-form-card .form-group .expense-form-label .expense-form-required,
.expense-form-card .form-group label .expense-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.expense-form-card .expense-form-group .expense-form-form-textarea,
.expense-form-card .form-group .expense-form-form-textarea {
  height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.expense-form-card .case-selector .clear-case-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 1;
}
.expense-form-card .case-selector .clear-case-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.expense-form-card .case-selector .clear-case-button:active {
  background-color: #e5e7eb;
}
.expense-form-card .expense-form-input-container {
  position: relative;
}
.expense-form-card .expense-form-input-container .expense-form-icon-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  pointer-events: none;
  color: #6b7280;
  font-weight: 500;
}
.expense-form-card .expense-form-input-container .expense-form-icon-container span {
  font-size: 0.875rem;
}
.expense-form-card .expense-form-input,
.expense-form-card .expense-form-form-select,
.expense-form-card .expense-form-form-textarea,
.expense-form-card .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.expense-form-card .expense-form-input:focus,
.expense-form-card .expense-form-form-select:focus,
.expense-form-card .expense-form-form-textarea:focus,
.expense-form-card .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.expense-form-card .expense-form-input::placeholder,
.expense-form-card .expense-form-form-select::placeholder,
.expense-form-card .expense-form-form-textarea::placeholder,
.expense-form-card .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.expense-form-card .expense-form-input:disabled,
.expense-form-card .expense-form-form-select:disabled,
.expense-form-card .expense-form-form-textarea:disabled,
.expense-form-card .custom-dropdown-input:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}
.expense-form-card .expense-form-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.expense-form-card .expense-form-input,
.expense-form-card .expense-form-form-select {
  padding-right: 2.5rem;
}
.expense-form-card .expense-form-flex-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-flex-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.expense-form-card .expense-form-flex-row .expense-form-col-half {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-label .expense-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input:focus,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input:hover:not(:focus),
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date:hover:not(:focus) {
  border-color: #9ca3af;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input::placeholder,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date::placeholder {
  color: #9ca3af;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input:disabled,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.expense-form-card .case-selector {
  position: relative;
}
.expense-form-card .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.expense-form-card .case-selector .dropdown-content .loading-state,
.expense-form-card .case-selector .dropdown-content .no-results,
.expense-form-card .case-selector .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.expense-form-card .case-selector .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.expense-form-card .case-selector .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.expense-form-card .upload-document-group .upload-document-container {
  border: 2px dashed #e2e8f0;
  border-radius: 0.375rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;
}
.expense-form-card .upload-document-group .upload-document-container:hover {
  border-color: #3a86ff;
  background-color: #f8fafc;
}
.expense-form-card .upload-document-group .upload-document-container:focus-within {
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.expense-form-card .upload-document-group .upload-document-container .upload-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  color: #6b7280;
}
.expense-form-card .upload-document-group .upload-document-container .upload-icon-container span {
  font-size: 0.875rem;
  font-weight: 500;
}
.expense-form-card .upload-document-group .upload-progress {
  margin-top: 1rem;
  text-align: center;
}
.expense-form-card .upload-document-group .upload-progress .progress-bar {
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}
.expense-form-card .upload-document-group .upload-progress .progress-bar .progress {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 4px;
  transition: width 0.3s ease;
}
.expense-form-card .upload-document-group .upload-progress span {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
}
.expense-form-card .upload-document-group .uploaded-file {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.expense-form-card .upload-document-group .uploaded-file a {
  color: #0369a1;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  flex: 1 1;
}
.expense-form-card .upload-document-group .uploaded-file a:hover {
  text-decoration: underline;
}
.expense-form-card .upload-document-group .uploaded-file .cancel-upload-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.expense-form-card .upload-document-group .uploaded-file .cancel-upload-button:hover {
  background-color: #dc2626;
}
.expense-form-card .upload-document-group .uploaded-file .cancel-upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}
.expense-form-card .expense-form-button-container {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-button-container {
    flex-direction: column;
  }
}
.expense-form-card .expense-form-button-container .expense-form-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-button-container .expense-form-btn {
    width: 100%;
  }
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save {
  background-color: var(--primary-color);
  color: white;
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save:hover {
  background-color: #005a9a;
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save:focus {
  outline: none;
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.expense-form-card .expense-form-button-container .expense-form-btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.expense-form-card .expense-form-button-container .expense-form-btn-cancel:hover {
  background-color: #f8f9fa;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.modal-expense-form-card {
  border: none;
  width: 100% !important;
}
.modal-expense-form-card .modal-expense-form-title {
  font-size: 1.3rem !important;
}

.client-modal-header .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.client-modal-header .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}
.client-modal-header .close-cross:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.exp-service-modal-body h3 {
  font-size: 1.2rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
}
.exp-service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
  height: 2.5rem;
}
.exp-service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.exp-service-modal-body .new-service-input::placeholder {
  color: #9ca3af;
}
.exp-service-modal-body .submit-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.exp-service-modal-body .submit-btn:hover {
  background-color: #005a9a;
}
.exp-service-modal-body .submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

@keyframes expense-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .expense-form-container .expense-form-card {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .expense-form-container {
    padding: 0.5rem;
  }
  .expense-form-container .expense-form-card {
    padding: 0.75rem;
  }
  .expense-form-container .expense-form-card .expense-form-title {
    font-size: 1.125rem;
  }
  .expense-form-container .expense-form-card .expense-form-group .expense-form-input,
  .expense-form-container .expense-form-card .expense-form-group .expense-form-form-select,
  .expense-form-container .expense-form-card .expense-form-group .expense-form-form-textarea,
  .expense-form-container .expense-form-card .expense-form-group .custom-dropdown-input,
  .expense-form-container .expense-form-card .form-group .expense-form-input,
  .expense-form-container .expense-form-card .form-group .expense-form-form-select,
  .expense-form-container .expense-form-card .form-group .expense-form-form-textarea,
  .expense-form-container .expense-form-card .form-group .custom-dropdown-input {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .expense-form-container .expense-form-card .expense-form-button-container .expense-form-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .expense-form-container {
    background: white;
    padding: 0;
  }
  .expense-form-container .expense-form-card {
    box-shadow: none;
    border: 1px solid #000;
  }
  .expense-form-container .expense-form-button-container,
  .expense-form-container .dropdown-content,
  .expense-form-container .expense-form-close-button {
    display: none;
  }
}
.expense-form-card input:focus-visible,
.expense-form-card select:focus-visible,
.expense-form-card textarea:focus-visible,
.expense-form-card button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* MODIFICATION: ADDED STYLES FOR THE NEW "ADD FIELD" MODAL */
.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Higher z-index to appear above the main form modal */
  padding: 20px;
  box-sizing: border-box;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  width: 700px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid #e5e7eb;
  position: relative;
  animation: expense-form-fade-in 0.2s ease-out;
}
.confirmation-modal.notinvoice {
  width: 420px;
  gap: 16px;
}
.confirmation-modal.notinvoice .branch-form-close-button {
  top: 12px;
  right: 12px;
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
.confirmation-actions.notinvoice {
  border-top: none;
  padding-top: 0;
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn:disabled,
.confirmation-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover:not(:disabled) {
  filter: brightness(95%);
}
.confirmation-actions .confirm-btn:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover:not(:disabled) {
  background: #4b5563;
}

.add-new-field-modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.add-new-field-modal-content h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: left;
  border-bottom: none;
  padding-bottom: 0;
}
.add-new-field-modal-content .add-new-field-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}
.add-new-field-modal-content .add-new-field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/forms/ExpenseForm/ExpenseForm.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EAVF;IAWI,aAAA;EAEF;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AACJ;AACI;EACE,yBAAA;EACA,cAAA;AACN;AAEI;EACE,aAAA;EACA,6CAAA;AAAN;;AAIA;EACE,wBAAA;EACA,gBAAA;AADF;;AAGA;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AAAJ;AAEI;EACE,0BAAA;AAAN;AAIE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAKI;EACE,aAAA;EACA,4CAAA;AAHN;;AASA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,6CAAA;EACA,UAAA;AANF;AAQE;EATF;IAUI,aAAA;IACA,WAAA;EALF;AACF;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AANJ;AAQI;EAPF;IAQI,kBAAA;EALJ;AACF;AASE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAPJ;AAWE;EACE,qBAAA;AATJ;AAaI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAXN;AAcI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAZN;AAiBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,gBAAA;AAfN;AAkBI;EATF;IAUI,sBAAA;IACA,WAAA;EAfJ;AACF;AAmBE;;EAEE,qBAAA;EACA,aAAA;EACA,sBAAA;AAjBJ;AAmBI;;EACE,gBAAA;AAhBN;AAmBI;;;;EAEE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAfN;AAiBM;;;;EACE,cAAA;EACA,oBAAA;AAZR;AAgBI;;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAbN;AAmBI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAjBN;AAmBM;EACE,yBAAA;EACA,cAAA;AAjBR;AAoBM;EACE,yBAAA;AAlBR;AAuBE;EACE,kBAAA;AArBJ;AAuBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AArBN;AAuBM;EACE,mBAAA;AArBR;AA0BE;;;;EAIE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAxBJ;AA0BI;;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AArBN;AA4BI;;;;EACE,cAAA;AAvBN;AA0BI;;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AArBN;AAyBE;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAvBJ;AA0BE;;EAEE,qBAAA;AAxBJ;AA4BE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AA1BJ;AA4BI;EALF;IAMI,sBAAA;IACA,WAAA;EAzBJ;AACF;AA2BI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAzBN;AA2BM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAzBR;AA2BQ;EACE,cAAA;EACA,oBAAA;AAzBV;AA6BM;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA3BR;AA6BQ;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA1BV;AA6BQ;;EACE,qBAAA;AA1BV;AA6BQ;;EACE,cAAA;AA1BV;AA6BQ;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AA1BV;AAiCE;EACE,kBAAA;AA/BJ;AAkCI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAjCN;AAmCM;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAjCR;AAmCQ;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AAjCV;AAmCU;EACE,mBAAA;EACA,cAAA;AAjCZ;AAoCU;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AAlCZ;AAoGM;EACE,iBAAA;EACA,gBAAA;AAlGR;AAoGQ;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AAlGV;AAoGU;EACE,mBAAA;AAlGZ;AAqGU;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAnGZ;AAqGY;EACE,gBAAA;AAnGd;AAwGY;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAtGd;AAyGY;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AAxGd;AA2GY;EACE,kBAAA;EACA,cAAA;AAzGd;AA8GQ;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA5GV;AAgHM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA9GR;AAiHM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA/GR;AAiHQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AA/GV;AAuHI;EACE,0BAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AArHN;AAuHM;EACE,qBAAA;EACA,yBAAA;AArHR;AAwHM;EACE,qBAAA;EACA,6CAAA;AAtHR;AAyHM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAvHR;AAyHQ;EACE,mBAAA;EACA,gBAAA;AAvHV;AA4HI;EACE,gBAAA;EACA,kBAAA;AA1HN;AA4HM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AA1HR;AA4HQ;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AA1HV;AA8HM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AA5HR;AAgII;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA9HN;AAgIM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AA9HR;AAgIQ;EACE,0BAAA;AA9HV;AAkIM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAhIR;AAkIQ;EACE,yBAAA;AAhIV;AAmIQ;EACE,aAAA;EACA,4CAAA;AAjIV;AAwIE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EAEA,iBAAA;EACA,6BAAA;AAvIJ;AAyII;EARF;IASI,sBAAA;EAtIJ;AACF;AAwII;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAtIN;AAwIM;EAVF;IAWI,WAAA;EArIN;AACF;AAuIM;EACE,sCAAA;EACA,YAAA;AArIR;AAuIQ;EACE,yBAAA;AArIV;AAwIQ;EACE,aAAA;AAtIV;AAyIQ;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAvIV;AA2II;EAmBE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA3JN;AA6JM;EACE,yBAAA;AA3JR;;AAgKA;;EAEE,wBAAA;EACA,SAAA;AA7JF;;AAgKA;EACE,YAAA;EACA,sBAAA;AA7JF;AA+JE;EACE,4BAAA;AA7JJ;;AAyKE;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AAtKJ;AAwKI;EACE,cAAA;EACA,yBAAA;AAtKN;AAyKI;EACE,aAAA;EACA,6CAAA;AAvKN;;AA+KE;EAKE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAhLJ;AAmLE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAjLJ;AAmLI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjLN;AAoLI;EACE,cAAA;AAlLN;AAsLE;EA2BE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA9MJ;AAgNI;EACE,yBAAA;AA9MN;AAiNI;EACE,yBAAA;EACA,mBAAA;AA/MN;;AAqNA;EACE;IACE,UAAA;IACA,2BAAA;EAlNF;EAqNA;IACE,UAAA;IACA,wBAAA;EAnNF;AACF;AAsNA;EACE;IACE,UAAA;IACA,2BAAA;EApNF;EAuNA;IACE,UAAA;IACA,wBAAA;EArNF;AACF;AAyNA;EACE,UAAA;AAvNF;;AA0NA;EACE,mBAAA;EACA,kBAAA;AAvNF;;AA0NA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAvNF;;AA0NA;EAGE,mBAAA;AAzNF;;AA6NA;EAEI;IACE,WAAA;EA3NJ;AACF;AA+NA;EACE;IACE,eAAA;EA7NF;EA+NE;IACE,gBAAA;EA7NJ;EA+NI;IACE,mBAAA;EA7NN;EAkOM;;;;;;;;IAIE,iBAAA;IACA,oBAAA;EA5NR;EAiOM;IACE,oBAAA;IACA,oBAAA;EA/NR;AACF;AAsOA;EACE;IACE,iBAAA;IACA,UAAA;EApOF;EAsOE;IACE,gBAAA;IACA,sBAAA;EApOJ;EAuOE;;;IAGE,aAAA;EArOJ;AACF;AA2OE;;;;EAIE,0BAAA;EACA,mBAAA;AAzOJ;;AA6OA,6DAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA,EAAA,uDAAA;EACA,aAAA;EACA,sBAAA;AA3OF;;AA8OA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;AA3OF;AA6OE;EACE,YAAA;EACA,SAAA;AA3OJ;AA6OI;EACE,SAAA;EACA,WAAA;AA3ON;;AAgPA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AA7OF;AA+OE;EACE,gBAAA;EACA,cAAA;AA7OJ;AAgPE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AA9OJ;AAgPI;;EACE,mBAAA;EACA,YAAA;AA7ON;AAiPE;EACE,gCAAA;EACA,YAAA;AA/OJ;AAiPI;EACE,uBAAA;AA/ON;AAkPI;EACE,yBAAA;EACA,cAAA;AAhPN;AAoPE;EACE,mBAAA;EACA,YAAA;AAlPJ;AAoPI;EACE,mBAAA;AAlPN;;AAwPA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArPF;AAuPE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AArPJ;AAwPE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AAtPJ;AAwPI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAtPN","sourcesContent":[".expense-form-container {\r\n  min-height: calc(100vh - 118px);\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n  // Close button for modal\r\n  .expense-form-close-button {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    z-index: 1001;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0.25rem;\r\n    transition: all 0.2s ease;\r\n\r\n    &:hover {\r\n      background-color: #f3f4f6;\r\n      color: #374151;\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}\r\n.modal-expense-form-container {\r\n  padding: 0rem !important;\r\n  min-height: auto;\r\n}\r\n.uploaded-file {\r\n  margin-top: 1rem;\r\n  padding: 0.75rem 1rem;\r\n  background-color: #f0f9ff;\r\n  border: 1px solid #bae6fd;\r\n  border-radius: 0.375rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 1rem;\r\n\r\n  a {\r\n    color: #0369a1;\r\n    text-decoration: none;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n    flex: 1;\r\n\r\n    &:hover {\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n\r\n  .cancel-upload-button {\r\n    background-color: #ef4444;\r\n    color: white;\r\n    border: none;\r\n    padding: 0.375rem 0.75rem;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.75rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n\r\n    &:hover {\r\n      background-color: #dc2626;\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\r\n    }\r\n  }\r\n}\r\n\r\n// Form Wrapper - Match LabelForm wrapper structure\r\n.expense-form-card {\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  animation: expense-form-fade-in 0.3s ease-out;\r\n  width: 70%;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n    width: 100%;\r\n  }\r\n\r\n  // Title styling\r\n  .expense-form-title {\r\n    font-size: 1.3rem;\r\n    font-weight: 500;\r\n    color: #374151;\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 1.25rem;\r\n    }\r\n  }\r\n\r\n  // Divider styling\r\n  .expense-form-divider {\r\n    border: none;\r\n    border-top: 1px solid #e5e7eb;\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n  // Form sections\r\n  .form-section {\r\n    margin-bottom: 1.5rem;\r\n    // padding-bottom: 1.5rem;\r\n    // border-bottom: 1px solid #f3f4f6;\r\n\r\n    &:last-of-type {\r\n      border-bottom: none;\r\n      margin-bottom: 0;\r\n      padding-bottom: 0;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n    }\r\n  }\r\n\r\n  // Form rows and groups\r\n  .form-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n\r\n  // Form groups\r\n  .expense-form-group,\r\n  .form-group {\r\n    margin-bottom: 0.5rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    .expense-form-label,\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n\r\n      .expense-form-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n    .expense-form-form-textarea {\r\n      height: 4rem;\r\n      resize: vertical;\r\n      line-height: 1.5;\r\n    }\r\n  }\r\n\r\n  // Case selector clear button\r\n  .case-selector {\r\n    .clear-case-button {\r\n      position: absolute;\r\n      right: 10px;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n      background: transparent;\r\n      border: none;\r\n      color: #6b7280;\r\n      font-size: 24px;\r\n      cursor: pointer;\r\n      padding: 0;\r\n      width: 24px;\r\n      height: 24px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 50%;\r\n      transition: all 0.2s ease;\r\n      z-index: 1;\r\n\r\n      &:hover {\r\n        background-color: #f3f4f6;\r\n        color: #374151;\r\n      }\r\n\r\n      &:active {\r\n        background-color: #e5e7eb;\r\n      }\r\n    }\r\n  }\r\n\r\n  .expense-form-input-container {\r\n    position: relative;\r\n\r\n    .expense-form-icon-container {\r\n      position: absolute;\r\n      top: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      display: flex;\r\n      align-items: center;\r\n      padding: 0 0.75rem;\r\n      pointer-events: none;\r\n      color: #6b7280;\r\n      font-weight: 500;\r\n\r\n      span {\r\n        font-size: 0.875rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .expense-form-input,\r\n  .expense-form-form-select,\r\n  .expense-form-form-textarea,\r\n  .custom-dropdown-input {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-family: inherit;\r\n    color: #374151;\r\n    background: #ffffff;\r\n    box-sizing: border-box;\r\n    height: 2.5rem;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n    &:hover:not(:focus) {\r\n      //border-color: #9ca3af;\r\n    }\r\n\r\n    &::placeholder {\r\n      color: #9ca3af;\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #e9ecef;\r\n      color: #6c757d;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  .expense-form-form-select {\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n    background-position: right 0.5rem center;\r\n    background-repeat: no-repeat;\r\n    background-size: 1.5rem 1.5rem;\r\n    padding-right: 2.5rem;\r\n  }\r\n\r\n  .expense-form-input,\r\n  .expense-form-form-select {\r\n    padding-right: 2.5rem;\r\n  }\r\n\r\n  // Two column layout for expense form\r\n  .expense-form-flex-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 0.5rem;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    .expense-form-col-half {\r\n      flex: 1;\r\n      display: flex;\r\n      flex-direction: column;\r\n\r\n      .expense-form-label {\r\n        display: block;\r\n        margin-bottom: 0.5rem;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        color: #374151;\r\n\r\n        .expense-form-required {\r\n          color: #ef4444;\r\n          margin-left: 0.25rem;\r\n        }\r\n      }\r\n\r\n      .expense-form-input,\r\n      .expense-form-input-date {\r\n        width: 100%;\r\n        padding: 0.5rem;\r\n        border: 1px solid #d1d5db;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.875rem;\r\n        font-family: inherit;\r\n        color: #374151;\r\n        background: #ffffff;\r\n        box-sizing: border-box;\r\n        height: 2.5rem;\r\n\r\n        &:focus {\r\n          outline: none;\r\n          border-color: #3b82f6;\r\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n        }\r\n\r\n        &:hover:not(:focus) {\r\n          border-color: #9ca3af;\r\n        }\r\n\r\n        &::placeholder {\r\n          color: #9ca3af;\r\n        }\r\n\r\n        &:disabled {\r\n          background-color: #f9fafb;\r\n          color: #6b7280;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Case Selector - Match LabelForm exactly\r\n  .case-selector {\r\n    position: relative;\r\n\r\n    // Dropdown content\r\n    .dropdown-content {\r\n      position: absolute;\r\n      top: 100%;\r\n      left: 0;\r\n      width: 100%;\r\n      background: #ffffff;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.375rem;\r\n      z-index: 1000;\r\n      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\r\n        0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n      margin-top: 0.25rem;\r\n      overflow: hidden;\r\n      animation: dropdown-fade-in 0.2s ease-out;\r\n\r\n      .dropdown-tabs {\r\n        display: flex;\r\n        background: #f9fafb;\r\n        border-bottom: 1px solid #e5e7eb;\r\n\r\n        button {\r\n          flex: 1;\r\n          padding: 0.75rem 1rem;\r\n          border: none;\r\n          background: transparent;\r\n          color: #6b7280;\r\n          font-weight: 500;\r\n          font-size: 0.875rem;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n          border-bottom: 2px solid transparent;\r\n\r\n          &:hover {\r\n            background: #f3f4f6;\r\n            color: #374151;\r\n          }\r\n\r\n          &.active {\r\n            background: #ffffff;\r\n            color: #3b82f6;\r\n            font-weight: 600;\r\n            border-bottom-color: #3b82f6;\r\n          }\r\n        }\r\n      }\r\n\r\n      //   .dropdown-options {\r\n      //     max-height: 250px;\r\n      //     overflow-y: auto;\r\n\r\n      //     .dropdown-option {\r\n      //       padding: 0.75rem 1rem;\r\n      //       cursor: pointer;\r\n      //       border-bottom: 1px solid #f3f4f6;\r\n      //       transition: all 0.2s ease;\r\n\r\n      //       &:hover {\r\n      //         background: #f9fafb;\r\n      //       }\r\n\r\n      //       &.selected {\r\n      //         background: #eff6ff;\r\n      //         //color: #1e40af;\r\n      //         border-left: 3px solid #3b82f6;\r\n\r\n      //         .case-parties {\r\n      //           font-weight: 600;\r\n      //         }\r\n      //       }\r\n\r\n      //       .case-info {\r\n      //         .case-parties {\r\n      //           font-weight: 500;\r\n      //           color: #374151;\r\n      //           font-size: 0.875rem;\r\n      //           margin-bottom: 0.25rem;\r\n      //           line-height: 1.4;\r\n\r\n      //         }\r\n\r\n      //         .case-ref {\r\n      //           font-size: 0.75rem;\r\n      //           color: #6b7280;\r\n      //           font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas, \"Liberation Mono\", Menlo, monospace;\r\n      //           background: #f3f4f6;\r\n      //           padding: 0.125rem 0.375rem;\r\n      //           border-radius: 0.25rem;\r\n      //           display: inline-block;\r\n      //           margin-bottom: 0.25rem;\r\n      //         }\r\n\r\n      //         .case-number {\r\n      //           font-size: 0.75rem;\r\n      //           color: #9ca3af;\r\n      //         }\r\n      //       }\r\n      //     }\r\n\r\n      //     .no-data {\r\n      //       padding: 2rem 1rem;\r\n      //       text-align: center;\r\n      //       color: #6b7280;\r\n      //       font-style: italic;\r\n      //       font-size: 0.875rem;\r\n      //     }\r\n      //   }\r\n      // }\r\n      .dropdown-options {\r\n        max-height: 250px;\r\n        overflow-y: auto;\r\n\r\n        .dropdown-option {\r\n          padding: 0.75rem 1rem;\r\n          cursor: pointer;\r\n          border-bottom: 1px solid #f3f4f6;\r\n          transition: all 0.2s ease;\r\n\r\n          &:hover {\r\n            background: #f9fafb;\r\n          }\r\n\r\n          &.selected {\r\n            background: #eff6ff;\r\n            color: #1e40af;\r\n            border-left: 3px solid #3b82f6;\r\n\r\n            .case-parties {\r\n              font-weight: 600;\r\n            }\r\n          }\r\n\r\n          .case-info {\r\n            .case-parties {\r\n              font-weight: 500;\r\n              color: #374151;\r\n              font-size: 0.875rem;\r\n              margin-bottom: 0.25rem;\r\n              line-height: 1.4;\r\n            }\r\n\r\n            .case-ref {\r\n              font-size: 0.75rem;\r\n              color: #6b7280;\r\n              font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\r\n                \"Liberation Mono\", Menlo, monospace;\r\n              background: #f3f4f6;\r\n              padding: 0.125rem 0.375rem;\r\n              border-radius: 0.25rem;\r\n              display: inline-block;\r\n              margin-bottom: 0.25rem;\r\n            }\r\n\r\n            .case-number {\r\n              font-size: 0.75rem;\r\n              color: #9ca3af;\r\n            }\r\n          }\r\n        }\r\n\r\n        .no-data {\r\n          padding: 2rem 1rem;\r\n          text-align: center;\r\n          color: #6b7280;\r\n          font-style: italic;\r\n          font-size: 0.875rem;\r\n        }\r\n      }\r\n\r\n      .loading-state,\r\n      .no-results,\r\n      .empty-state {\r\n        padding: 2rem 1rem;\r\n        text-align: center;\r\n        color: #6b7280;\r\n        font-style: italic;\r\n        font-size: 0.875rem;\r\n      }\r\n\r\n      .loading-state {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 0.5rem;\r\n\r\n        &::before {\r\n          content: \"\";\r\n          width: 16px;\r\n          height: 16px;\r\n          border: 2px solid #e5e7eb;\r\n          border-top: 2px solid #3b82f6;\r\n          border-radius: 50%;\r\n          animation: spin 1s linear infinite;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Upload document styles\r\n  .upload-document-group {\r\n    .upload-document-container {\r\n      border: 2px dashed #e2e8f0;\r\n      border-radius: 0.375rem;\r\n      padding: 2rem;\r\n      text-align: center;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n      background: #fafafa;\r\n\r\n      &:hover {\r\n        border-color: #3a86ff;\r\n        background-color: #f8fafc;\r\n      }\r\n\r\n      &:focus-within {\r\n        border-color: #3a86ff;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      .upload-icon-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        gap: 0.75rem;\r\n        color: #6b7280;\r\n\r\n        span {\r\n          font-size: 0.875rem;\r\n          font-weight: 500;\r\n        }\r\n      }\r\n    }\r\n\r\n    .upload-progress {\r\n      margin-top: 1rem;\r\n      text-align: center;\r\n\r\n      .progress-bar {\r\n        width: 100%;\r\n        height: 8px;\r\n        background-color: #e5e7eb;\r\n        border-radius: 4px;\r\n        overflow: hidden;\r\n        margin-bottom: 0.5rem;\r\n\r\n        .progress {\r\n          height: 100%;\r\n          background-color: #3b82f6;\r\n          border-radius: 4px;\r\n          transition: width 0.3s ease;\r\n        }\r\n      }\r\n\r\n      span {\r\n        font-size: 0.75rem;\r\n        color: #6b7280;\r\n        font-weight: 500;\r\n      }\r\n    }\r\n\r\n    .uploaded-file {\r\n      margin-top: 1rem;\r\n      padding: 0.75rem 1rem;\r\n      background-color: #f0f9ff;\r\n      border: 1px solid #bae6fd;\r\n      border-radius: 0.375rem;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      gap: 1rem;\r\n\r\n      a {\r\n        color: #0369a1;\r\n        text-decoration: none;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        flex: 1;\r\n\r\n        &:hover {\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n\r\n      .cancel-upload-button {\r\n        background-color: #ef4444;\r\n        color: white;\r\n        border: none;\r\n        padding: 0.375rem 0.75rem;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.75rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n\r\n        &:hover {\r\n          background-color: #dc2626;\r\n        }\r\n\r\n        &:focus {\r\n          outline: none;\r\n          box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Form actions to match LabelForm\r\n  .expense-form-button-container {\r\n    display: flex;\r\n    justify-content: end;\r\n    gap: 1rem;\r\n    //margin-top: 1rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n    }\r\n\r\n    .expense-form-btn {\r\n      padding: 0.75rem 1.5rem;\r\n      border: none;\r\n      border-radius: 0.375rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      cursor: pointer;\r\n      min-width: 120px;\r\n      transition: all 0.2s ease;\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n      }\r\n\r\n      &.expense-form-btn-save {\r\n        background-color: var(--primary-color);\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #005a9a;\r\n        }\r\n\r\n        &:focus {\r\n          outline: none;\r\n        }\r\n\r\n        &:disabled {\r\n          background-color: #d1d5db;\r\n          color: #9ca3af;\r\n          cursor: not-allowed;\r\n          opacity: 0.6;\r\n        }\r\n      }\r\n    }\r\n    .expense-form-btn-cancel {\r\n      // background-color: #dc2626;\r\n      // color: white;\r\n\r\n      // &:hover:not(:disabled) {\r\n      //   background-color: #b91c1c;\r\n      // }\r\n\r\n      // &:focus {\r\n      //   outline: none;\r\n      //   box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\r\n      // }\r\n\r\n      // &:disabled {\r\n      //   background-color: #d1d5db;\r\n      //   color: #9ca3af;\r\n      //   cursor: not-allowed;\r\n      //   opacity: 0.6;\r\n      // }\r\n      padding: 8px 16px;\r\n      border: 1px solid #ddd;\r\n      background: white;\r\n      color: #666;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      font-size: 14px;\r\n\r\n      &:hover {\r\n        background-color: #f8f9fa;\r\n      }\r\n    }\r\n  }\r\n}\r\n.no-spinner::-webkit-outer-spin-button,\r\n.no-spinner::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.modal-expense-form-card {\r\n  border: none;\r\n  width: 100% !important;\r\n\r\n  .modal-expense-form-title {\r\n    font-size: 1.3rem !important;\r\n  }\r\n}\r\n\r\n// Modal styles\r\n.client-modal-header {\r\n  // display: flex;\r\n  // justify-content: flex-end;\r\n  // padding: 1rem;\r\n  // background-color: #f9fafb;\r\n  // border-bottom: 1px solid #e5e7eb;\r\n\r\n  .close-cross {\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0.25rem;\r\n    transition: all 0.2s ease;\r\n\r\n    &:hover {\r\n      color: #374151;\r\n      background-color: #f3f4f6;\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n.exp-service-modal-body {\r\n  //padding: 1.5rem;\r\n\r\n  h3 {\r\n    // font-size: 1.25rem;\r\n    // font-weight: 500;\r\n    // color: #374151;\r\n    // margin: 0 0 1rem 0;\r\n    font-size: 1.2rem;\r\n    font-weight: 500;\r\n    color: #374151;\r\n    margin: 0 0 1rem 0;\r\n  }\r\n\r\n  .new-service-input {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    margin-bottom: 1rem;\r\n    box-sizing: border-box;\r\n    height: 2.5rem;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n    &::placeholder {\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n\r\n  .submit-btn {\r\n    // background-color: #16a34a;\r\n    // color: white;\r\n    // border: none;\r\n    // padding: 0.75rem 1.5rem;\r\n    // border-radius: 0.375rem;\r\n    // font-size: 0.875rem;\r\n    // font-weight: 500;\r\n    // cursor: pointer;\r\n    // min-width: 120px;\r\n    // transition: all 0.2s ease;\r\n\r\n    // &:hover:not(:disabled) {\r\n    //   background-color: #15803d;\r\n    // }\r\n\r\n    // &:focus {\r\n    //   outline: none;\r\n    //   box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n    // }\r\n\r\n    // &:disabled {\r\n    //   background-color: #d1d5db;\r\n    //   color: #9ca3af;\r\n    //   cursor: not-allowed;\r\n    //   opacity: 0.6;\r\n    // }\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      background-color: #005a9a;\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #9ca3af;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes expense-form-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes dropdown-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Scrollbar styling for dropdown\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 3px;\r\n}\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.case-selector\r\n  .dropdown-content\r\n  .dropdown-options::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n// Responsive design improvements\r\n@media (max-width: 768px) {\r\n  .expense-form-container {\r\n    .expense-form-card {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .expense-form-container {\r\n    padding: 0.5rem;\r\n\r\n    .expense-form-card {\r\n      padding: 0.75rem;\r\n\r\n      .expense-form-title {\r\n        font-size: 1.125rem;\r\n      }\r\n\r\n      .expense-form-group,\r\n      .form-group {\r\n        .expense-form-input,\r\n        .expense-form-form-select,\r\n        .expense-form-form-textarea,\r\n        .custom-dropdown-input {\r\n          padding: 0.375rem;\r\n          font-size: 0.8125rem;\r\n        }\r\n      }\r\n\r\n      .expense-form-button-container {\r\n        .expense-form-btn {\r\n          padding: 0.5rem 1rem;\r\n          font-size: 0.8125rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .expense-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    .expense-form-card {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .expense-form-button-container,\r\n    .dropdown-content,\r\n    .expense-form-close-button {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Focus visible improvements for accessibility\r\n.expense-form-card {\r\n  input:focus-visible,\r\n  select:focus-visible,\r\n  textarea:focus-visible,\r\n  button:focus-visible {\r\n    outline: 2px solid #3b82f6;\r\n    outline-offset: 2px;\r\n  }\r\n}\r\n\r\n/* MODIFICATION: ADDED STYLES FOR THE NEW \"ADD FIELD\" MODAL */\r\n\r\n.confirmation-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1050; /* Higher z-index to appear above the main form modal */\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.confirmation-modal {\r\n  background: #ffffff;\r\n  padding: 24px;\r\n  border-radius: 8px;\r\n  width: 700px;\r\n  max-width: 95%;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  border: 1px solid #e5e7eb;\r\n  position: relative;\r\n  animation: expense-form-fade-in 0.2s ease-out;\r\n\r\n  &.notinvoice {\r\n    width: 420px;\r\n    gap: 16px;\r\n\r\n    .branch-form-close-button {\r\n      top: 12px;\r\n      right: 12px;\r\n    }\r\n  }\r\n}\r\n\r\n.confirmation-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid #e5e7eb;\r\n\r\n  &.notinvoice {\r\n    border-top: none;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .confirm-btn,\r\n  .cancel-btn {\r\n    padding: 8px 18px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    min-width: 80px;\r\n\r\n    &:disabled {\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n\r\n  .confirm-btn {\r\n    background: var(--primary-color);\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      filter: brightness(95%);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #d1d5db;\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n\r\n  .cancel-btn {\r\n    background: #6b7280;\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      background: #4b5563;\r\n    }\r\n  }\r\n}\r\n\r\n// Styles for the content within the new modal\r\n.add-new-field-modal-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n\r\n  h3 {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n    margin: 0;\r\n    text-align: left;\r\n    border-bottom: none;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .add-new-field-input {\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    box-sizing: border-box;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
